import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AxisSpinner from "../components/AxisSpinner";

export const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  if (!token) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};


export const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const { token, authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    authAxios()
      .get("/api/backoffice/users/current_user")
      .then((response) => setRole(response?.data?.role || null))
      .catch((error) => {
        console.log("Error fetching current user role", error);
        setRole(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  if (!token) return <Navigate to="/login" />;
  if (loading) return <AxisSpinner loading={loading} />;
  if (!allowedRoles.includes(role)) return <Navigate to="/" replace />;

  return children;
};
